import { render } from "./BMSProjectMetaEdit.vue?vue&type=template&id=f3fd42e2&scoped=true"
import script from "./BMSProjectMetaEdit.vue?vue&type=script&lang=js"
export * from "./BMSProjectMetaEdit.vue?vue&type=script&lang=js"

import "./BMSProjectMetaEdit.vue?vue&type=style&index=0&id=f3fd42e2&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fd42e2"]])

export default __exports__